angular.module('vastdesk').
  component('demandEnvironment',  {
    bindings: {
      formName: '@',
      environment: '@',
      environmentOptions: '<'
    },
    template: require("../templates/demandEnvironment.html"),
    controllerAs: '$demandEnvironmentCtrl',
    controller: ['$rootScope', function($rootScope) {

      var self = this;
      var bodySelector = $('body');

      var broadcastSsbFieldChange = function() {
        $rootScope.$broadcast('ssbFieldChange', {
          environment: self.environment
        });
      };

      var toggleEnvClasses = function() {
        $('.in-app-ctv-hidden').toggleClass('hidden', _.includes(['in_app', 'ctv'], self.environment));
        $('.desktop-mobile-web-hidden').toggleClass('hidden', _.includes(['desktop', 'mobile_web'], self.environment));
        $('.ctv-hidden').toggleClass('hidden', self.environment === 'ctv');
      };

      this.setEnvironment = function(environment) {
        self.environment = environment;

        $rootScope.$broadcast('environmentChange', {
          environment: environment
        });

        toggleEnvClasses();
        broadcastSsbFieldChange();
      };

      setTimeout(function() {
        toggleEnvClasses();
      }, 0);

    }]
});
